export default __webpack_public_path__ + "static/media/info_white.e179f797.png";